import ApiService from '@/services/api';

// TYPES

export type TCreateBillingPortalSessionMaterials = {
  companyId: number;
};

export type TCreateBillingPortalSessionResponse = {
  /** Stripe-hosted portal to redirect the admin to. */
  portal_url: string;
};

/**
 * Opens Stripe's customer portal, where the subscription, payment method,
 * invoices and billing details are managed. Answers 409 while the company is
 * still on its trial and has nothing to manage.
 */
export const createBillingPortalSession = async ({
  companyId,
}: TCreateBillingPortalSessionMaterials): Promise<TCreateBillingPortalSessionResponse> => {
  const endpoint = `/v1/companies/${companyId}/licenses/billing-portal/`;
  const response = await ApiService.post(endpoint, {});
  return response?.data;
};
